/**
 * Flooded / Purple-Blue-Red.
 */ var PurpleBlueRed = [
    /**
     * Blue Props.
     */ {
        variant: 'blue',
        size: '1120',
        rotate: 50,
        blur: 21.3,
        x: '91',
        y: '398'
    },
    /**
     * Violet Props.
     */ {
        variant: 'violet',
        size: '1079',
        rotate: -130,
        blur: 19.3,
        x: '563',
        y: '-539'
    },
    /**
     * Blue Props.
     */ {
        variant: 'red',
        size: '986',
        rotate: -130,
        blur: 21.3,
        x: '-493',
        y: '660'
    }
];

export { PurpleBlueRed as default };
//# sourceMappingURL=purple-blue-red.es.js.map
